<footer class="page-footer">
  <div class="row">
    <a target="_blank" href="https://www.republicservices.com/privacy-policy"
      >Privacy Policy</a
    >
    <a
      target="_blank"
      href="https://www.republicservices.com/cms/documents/RepublicServicesWebsitePrivacyPolicy_Jan12021.pdf#page=8"
      >CA Privacy Rights</a
    >
    <a target="_blank" href="https://www.republicservices.com/terms-of-use"
      >Terms of Use</a
    >
  </div>
</footer>
